import script from "./NavItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavItem.vue?vue&type=script&setup=true&lang=ts"

import "./NavItem.vue?vue&type=style&index=0&id=67075d3c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67075d3c"]])

export default __exports__